import { useAuth, isCrmRole } from '@/composables/useAuth';
import { PathComponentEnum } from '@/router/constants';
import { getRouteLocale } from '@/router/navigation';

export const SALES_CRM_USER_IDS = [
  'U7NLytHfwT5fRqGdZmNu',
];

export const isSalesCrmUserId = (userId) => SALES_CRM_USER_IDS.includes(userId);
export const isSalesCrmUser = (userId, userRole) => (
  isSalesCrmUserId(userId) || isCrmRole(userRole)
);

export function salesCrmAccessMiddleware(to, from, next) {
  const { uid, role, isAuthenticated } = useAuth();
  if (!isAuthenticated.value) return next();

  if (to.meta.authArea === 'sales-crm') {
    if (isSalesCrmUser(uid.value, role.value)) return next();

    return next({
      name: PathComponentEnum.accessError,
      params: { locale: getRouteLocale(to) },
    });
  }

  if (to.meta.requiresAuth && isSalesCrmUser(uid.value, role.value)) {
    return next({
      name: 'sales-crm:clients',
      params: { locale: getRouteLocale(to) },
    });
  }

  return next();
}
